import React,{ Component } from 'react';
import PropTypes from 'prop-types';

class HiddenInput extends Component {
  render(){
    return (
      <input
        type='hidden'
        name={this.props.name}
        value={this.props.value}
      />
    )
  }
}

HiddenInput.propTypes = {
  name:PropTypes.string.isRequired,
  value:PropTypes.any
};

HiddenInput.defaultProps = {
  value:''
}

export default HiddenInput;



// WEBPACK FOOTER //
// ./src/shared/components/HiddenInput/index.js